import React, { memo, useCallback, useState } from "react";
import { Table } from "reactstrap";
import numeral from "numeral";
import { LISA } from "types";
import Button from "shared/components/Button";
import _ from "lodash";
import ApiCaller from "api/apiCaller";

type RowItemProps = {
  row: LISA.LeasePaymentScheduleApiData;
};

const RowItem = memo(function RowItem({ row }: RowItemProps) {
  const [isDeleted, setIsDeleted] = useState(false);

  const handleDeleteClick = useCallback(async (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault();

    try {
      const resp = await ApiCaller.delete(`site_lease_payment_schedule/${row.id}`)
      setIsDeleted(true);
    } catch (e) {
      alert(e.message);
    }
  }, [row.id]);

  if (isDeleted) {
    return null;
  }

  return (
    <tr>
      <td>
        <div>{row.month_year.split?.("-")?.[0]}</div>
      </td>
      <td>
        <div>{row.month_year.split?.("-")?.[1]}</div>
      </td>
      <td>
        <div>{numeral(row.lease_amount_paid).format("0,0")}</div>
      </td>
      <td>
        <div>{numeral(row.lease_amount_scheduled).format("0,0")}</div>
      </td>
      <td>
        <Button label="Delete" size="small" type="danger" onClick={handleDeleteClick} />
      </td>
    </tr>
  );
}, _.isEqual);

type PaymentScheduleTableProps = {
  data: Array<LISA.LeasePaymentScheduleApiData>;
};

const PaymentScheduleTable = memo(function PaymentScheduleTable({ data }: PaymentScheduleTableProps) {
  const renderRow = useCallback((row: LISA.LeasePaymentScheduleApiData) => {
    return <RowItem row={row} key={row.id} />;
  }, []);

  return (
    <div style={{ maxHeight: 600, overflow: "auto" }}>
      <Table responsive striped>
        <thead>
          <tr>
            <th>
              <div className="table-header">
                <span>Year</span>
              </div>
            </th>
            <th>
              <div className="table-header">
                <span>Month</span>
              </div>
            </th>
            <th>
              <div className="table-header">
                <span>Lease amount paid</span>
              </div>
            </th>
            <th>
              <div className="table-header">
                <span>Lease amount scheduled</span>
              </div>
            </th>
            <th>&nbsp;</th>
          </tr>
        </thead>
        <tbody>{data.map(renderRow)}</tbody>
      </Table>
    </div>
  );
}, _.isEqual);

export default PaymentScheduleTable;
